import * as actionTypes from '../actions/types';
import { updateObject } from '../../constants/utility';

const initialState = {
    isLoading: false,
    isComplete: null,
    error: null,
    data: null,
};

const paymentsOffersStart = (state) =>
    updateObject(state, { isLoading: true, isComplete: false, error: null });

const paymentsOffersSuccess = (state, action) =>
    updateObject(state, {
        isLoading: false,
        isComplete: true,
        error: null,
        data: action.data.offers,
    });

const paymentsOffersFail = (state, action) =>
    updateObject(state, {
        isLoading: false,
        isComplete: null,
        error: action.error,
        data: null,
    });

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.PAYMENTS_OFFERS_START:
            return paymentsOffersStart(state);
        case actionTypes.PAYMENTS_OFFERS_SUCCESS:
            return paymentsOffersSuccess(state, action);
        case actionTypes.PAYMENTS_OFFERS_FAIL:
            return paymentsOffersFail(state, action);
        default:
            return state;
    }
};

export default reducer;
